export type EScript20230411Operation = (typeof eScript20230411Operations)[number]

export const eScript20230411ParamsToRemove = ['v', 'op', 'promocode', 'products', 'ec'] as const

export const eScript20230411Operations = ['replaceAll'] as const

export const eScript20230411AnonymousCampaign = '[ANONYMOUS]'
